import Vue from 'vue';
import Router from 'vue-router';
import Player from '@/components/Player';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Player',
      component: Player,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js